var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeColor = function SvgYoutubeColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 .5C5.373.5 0 5.873 0 12.5s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12Zm5 7.875c.552.15.985.596 1.133 1.162.267 1.024.267 3.163.267 3.163s0 2.138-.267 3.163A1.625 1.625 0 0 1 17 17.025C16.003 17.3 12 17.3 12 17.3s-4.003 0-5-.275a1.625 1.625 0 0 1-1.133-1.162C5.6 14.838 5.6 12.7 5.6 12.7s0-2.138.267-3.163C6.015 8.97 6.448 8.526 7 8.375 7.997 8.1 12 8.1 12 8.1s4.003 0 5 .275Z",
    fill: "#4D7579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 14.9v-4l3.2 2-3.2 2Z",
    fill: "#4D7579"
  })));
};
export default SvgYoutubeColor;